export default [
  {
    path: '/mobile/message/list',
    name: 'mobile-message-list',
    component: () => import('@/views/mobile/message/MessageList.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '我的消息',
    },
  },
  {
    path: '/mobile/message/subscribe-setting',
    name: 'mobile-message-subscribe-setting',
    component: () => import('@/views/mobile/message/SubscribeSetting.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '消息订阅设置',
    },
  },
  {
    path: '/mobile/message/review/:id',
    name: 'mobile-message-review',
    component: () => import('@/views/admin/main/components/message/Review.vue'), // 该组件同时适用于移动端和非移动端多套路由地址
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '消息详情',
    },
  },
  {
    path: '/mobile/flow/redirect-external',
    name: 'mobile-flow-redirect-external',
    component: () => import('@/views/front/flow/message/Redirect.vue'), // 该组件同时适用于移动端和非移动端多套路由地址
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '消息中转',
    },
  },
];
